/* assets/card-images.js */

if (!customElements.get('card-images')) {
  customElements.define(
    'card-images',
    class CardImages extends HTMLElement {
      constructor() {
        super();

        this.sliderInstance = null;

        // Liquid側で出すdata属性
        this.enableSlider = this.dataset.enableSlider === 'true';
        this.items = this.dataset.items || '3';
        this.tabletItems = this.dataset.tabletItems || '2';

        this.classes = {
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
          swiperSlide: 'swiper-slide',
          ready: 'is-swiper-ready'
        };

        this.sliderWrapper = this.querySelector('.card-images__items');

        // 監視/ハンドラ
        this._onResize = this._onResize.bind(this);
        this._resizeRaf = null;
        this._hasInited = false;
      }

      connectedCallback() {
        if (!this.enableSlider) return;
        if (!this.sliderWrapper) return;
        if (this.sliderInstance) return;

        // 初期化前は ready を外しておく（CSSで隠す運用ならここが効く）
        this.classList.remove(this.classes.ready);

        // 初期描画直後はフォント/画像/CSS反映でサイズが揺れるので、2rafで落ち着かせてから初期化
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.initSlider();
          });
        });

        // リサイズ時にupdate（初期化後のみ）
        window.addEventListener('resize', this._onResize, { passive: true });
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this._onResize);
        this.destroySlider();
      }

      _onResize() {
        if (!this.sliderInstance) return;

        if (this._resizeRaf) cancelAnimationFrame(this._resizeRaf);
        this._resizeRaf = requestAnimationFrame(() => {
          const swiper = this._getSwiperInstance();
          if (swiper && typeof swiper.update === 'function') {
            swiper.update();
          }
        });
      }

      _getSwiperInstance() {
        // FoxTheme.Carousel の実装差を吸収（どれかに入っているはず）
        return (
          this.sliderInstance?.swiper ||
          this.sliderInstance?.instance ||
          this.sliderInstance?.slider ||
          this.sliderInstance?._swiper ||
          null
        );
      }

      _ensureStructure() {
        // 最低限の構造保証（Liquidで付けてる想定だが保険）
        this.classList.add(this.classes.swiper);

        if (!this.sliderWrapper.classList.contains(this.classes.swiperWrapper)) {
          this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        }

        const children = Array.from(this.sliderWrapper.children || []);
        children.forEach((el) => {
          if (el && el.classList && !el.classList.contains(this.classes.swiperSlide)) {
            el.classList.add(this.classes.swiperSlide);
          }
        });
      }

      _getInitialSlidesPerView() {
        const desktopCount = parseInt(this.items, 10) || 3;
        const tabletCount = parseInt(this.tabletItems, 10) || 2;

        // 初期から「いまの画面幅」に合わせた枚数で起動（1枚→3枚の切替を防ぐ）
        const isDesktop = window.matchMedia('(min-width: 1280px)').matches;
        const isTablet = window.matchMedia('(min-width: 768px)').matches;

        if (isDesktop) return desktopCount;
        if (isTablet) return tabletCount;
        return 1;
      }

      initSlider() {
        if (this.sliderInstance) return;
        if (!this.enableSlider) return;
        if (!this.sliderWrapper) return;

        // FoxTheme.Carousel がまだなら諦める（読み込み順の問題）
        if (!window.FoxTheme || !window.FoxTheme.Carousel) {
          return;
        }

        this._ensureStructure();

        const desktopCount = parseInt(this.items, 10) || 3;
        const tabletCount = parseInt(this.tabletItems, 10) || 2;

        const sliderOptions = {
          // ★初期から適切な枚数で起動
          slidesPerView: this._getInitialSlidesPerView(),
          spaceBetween: 12,
          breakpoints: {
            768: {
              slidesPerView: tabletCount,
              spaceBetween: 16
            },
            1280: {
              slidesPerView: desktopCount,
              spaceBetween: 20
            }
          }
        };

        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);

        if (typeof this.sliderInstance.init === 'function') {
          this.sliderInstance.init();
        }

        // init直後はまだサイズ計算が揺れることがあるので、
        // 2rafでupdateしてから ready（表示）にする
        const swiper = this._getSwiperInstance();

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            if (swiper && typeof swiper.update === 'function') {
              swiper.update();
            }
            this.classList.add(this.classes.ready);
            this._hasInited = true;
          });
        });
      }

      destroySlider() {
        if (!this.sliderInstance) return;

        try {
          const swiper = this._getSwiperInstance();
          if (swiper && typeof swiper.destroy === 'function') {
            // Swiper本体を直接破棄できるなら
            swiper.destroy(true, true);
          } else if (typeof this.sliderInstance.destroy === 'function') {
            // ラッパーのdestroyがあるなら
            this.sliderInstance.destroy();
          }
        } catch (e) {
          // 破棄失敗は致命的ではない
        } finally {
          this.sliderInstance = null;
          this._hasInited = false;
          this.classList.remove(this.classes.ready);
        }
      }
    }
  );
}
